import * as R from "remeda"

import type {
	CustomerNeed,
	Issue,
	LinearRoadmap,
	Project,
} from "@productlane/zero"

export type AugmentedProject = Project & {
	linearRoadmaps: readonly LinearRoadmap[]
	customerNeeds: readonly CustomerNeed[]
	issues?: readonly Issue[]
}

export type AugmentedIssue = Issue & {
	customerNeeds: readonly CustomerNeed[]
}

export type ProjectOrIssue =
	| {
			type: "project"
			data: AugmentedProject
	  }
	| {
			type: "issue"
			data: Issue
	  }

export type ProjectsOrIssues =
	| {
			type: "project"
			data: Array<AugmentedProject>
	  }
	| {
			type: "issue"
			data: Array<Issue>
	  }

export function groupProjectsByLinearRoadmaps(
	projects: Array<AugmentedProject>,
	isEnabled: boolean,
) {
	if (!isEnabled) {
		return {
			projectsWithRoadmaps: [],
			projectsWithoutRoadmaps: projects,
		}
	}

	try {
		const roadmaps = R.uniqBy(
			projects
				.flatMap((i) => i.linearRoadmaps)
				.map((it) => ({
					id: it.id,
					name: it.name,
				})),
			(i) => i.id,
		)
		const projectsWithRoadmaps = roadmaps.map((roadmap) => ({
			...roadmap,
			projects: projects.filter((i) =>
				i.linearRoadmaps.find((it) => it.id === roadmap.id),
			),
		}))

		const projectsWithoutRoadmaps = projects.filter(
			(i) => i.linearRoadmaps.length === 0,
		)

		return {
			projectsWithRoadmaps,
			projectsWithoutRoadmaps,
		}
	} catch (error) {
		return {
			projectsWithRoadmaps: [],
			projectsWithoutRoadmaps: projects,
		}
	}
}
